export const text = {
  title: "Tại sao lại chọn PhongTro123.com?",
  description1:
    "Chúng tôi biết bạn có rất nhiều lựa chọn, nhưng Phongtro123.com tự hào là trang web đứng top google về các từ khóa:",
  description2:
    "...Vì vậy tin của bạn đăng trên website sẽ tiếp cận được với nhiều khách hàng hơn, do đó giao dịch nhanh hơn, tiết kiệm chi phí hơn",
  statistic: [
    {
      name: "Chủ nhà & Môi giới",
      value: "130.000+",
    },
    {
      name: "Tin đăng",
      value: "200.000+",
    },
    {
      name: "Tin đăng/ngày",
      value: "1.000+",
    },
    {
      name: "Lượt xem/tháng",
      value: "3.000.000+",
    },
  ],
  price: "Chi phí thấp, hiệu quả tối đa",
  comment:
    "Trước khi biết website phongtro123, mình phải tốn nhiều công sức và chi phí cho việc đăng tin cho thuê: từ việc phát tờ rơi, dán giấy, và đăng lên các website khác nhưng hiệu quả không cao. Từ khi biết website phongtro123.com, mình đã thử đăng tin lên và đánh giá hiệu quả khá cao trong khi chi phí khá thấp, không còn tình trạng phòng trống kéo dài",
  author: " Anh Khánh (chủ hệ thống phòng trọ tại Tp.HCM)",
  question: "Bạn đang có phòng trọ / căn hộ cho thuê?",
  answer: "Không phải lo tìm người cho thuê, phòng trống kéo dài",
};
